export function getEmployerUnitForInsuredId(insuredId: string): string|null {
    const employerUnits = JSON.parse(document.body.dataset.insuredAllEmployerUnits);

    return employerUnits[insuredId] || null;
}

export function getCurrentEmployerUnit(): string | null {
    return document.body.dataset.currentEmployerUnit ?? null;
}

export function isDenner(): boolean {
    return 'denner' === document.body.dataset.currentEmployerUnit?.toLowerCase();
}
